import {createProject, getProjects} from '@/models/project'
const initialState = {}; // can load from localStorage

export default {
  ...initialState,
  config: {
    tab: 'master-awb'
  },
  canLoadHAWB: false,
  documentId: null,
  mawbNofFound: false,
  loadingMAWB: false,
  mawb: {},
  hawb: {},
  hawbs: [],
  loadingHAWB: false,
  hawbsNotFound: false,
  showForm: false,
  mawbDocumentLoaded: false,
  hawbDocumentLoaded: false,
  activeTab: "mawb",
  mawbDocumentImage: null,
  hawbDocumentImage: null,
  selection: {},
  airlines: [],
  handlingCodes: [],
  currencies: [],
  rateClasses: [],
  otherCharges: [],
  countries: [],
  searchDepartureList: [],
  searchArrival: null,
  searchArrivalList: [],
  searchAirline: null
}
